import React from 'react';
import c from 'classnames';
import i18next from 'i18next';

import { WysiwygField } from '../../../components';

const ParagraphChapterSection = (props) => {
  const {
    id,
    entity,
    className,
  } = props;

  const paragraph = entity.toJS();
  const classNames = c('ParagraphChapterSection', className);

  const title = paragraph.field_title[0].value;
  const sectionNumber = paragraph.field_number[0].value;
  const body = paragraph.field_body[0].processed;

  const sectionTitle = i18next.t('paragraph.chapter_section.title', { number: sectionNumber, title });

  return (
    <article className={classNames} id={id}>
      <h3>{sectionTitle}</h3>

      <WysiwygField
        className="ParagraphChapterSection__body"
        property="schema:text"
        html={body}
      />
    </article>
  );
};

export default ParagraphChapterSection;
